<button
	mat-raised-button
	(click)="_clicked()"
	type="button"
	[disabled]="disabled"
	[TealiumLink]="{ interaction_type: 'button' }"
>
	<template #componentContainer> </template>
	<ng-content *ngIf="!_component" select=".layout"></ng-content>
	<div class="tags" *ngIf="tags && tags.length > 0">
		<div
			class="tag"
			[ngClass]="'tag-' + i"
			*ngFor="let tag of tags; let i = index"
		>
			<img src="/assets/img/badge-dark-triangle.svg" />
			{{ tag }}
		</div>
	</div>

	<div class="toggle-icon" *ngIf="!disabled && isRadio">
		<div class="blank" *ngIf="!__active">
			<img src="assets/img/icons/blank.svg" alt="blank" />
		</div>
		<div class="radio" *ngIf="__active">
			<img src="assets/img/icons/radio.svg" alt="radio" />
		</div>
	</div>
	<div class="toggle-icon" *ngIf="disabled && isRadio">
		<div class="blank">
			<img src="assets/img/icons/radio-disabled.svg" alt="disabled" />
		</div>
	</div>
	<div class="toggle-icon" *ngIf="!disabled && isCheckBox">
		<div class="blank" *ngIf="!__active">
			<img src="assets/img/icons/square.svg" alt="blank" />
		</div>
		<div class="radio" *ngIf="__active">
			<img src="assets/img/icons/square-ticked.svg" alt="radio" />
		</div>
	</div>
</button>
<div class="title-below-button" *ngIf="titleBelowButton">
	{{ titleBelowButton }}
</div>
<ng-content select="[info]"></ng-content>
